import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/cherry/collect/init', method: 'GET', params }, { interceptResultCode: false });
};

// 查询用户当前集卡信息
export const collectShow = (params) => {
  return axios({ url: '/cherry/collect/show', method: 'GET', params }, { interceptResultCode: false });
};

// 领取奖励
export const reward = (params) => {
  return axios({ url: '/cherry/collect/reward', method: 'POST', params }, { interceptResultCode: false });
};

// 生成赠送卡片
export const generateCode = (data) => {
  return axios({ url: '/cherry/collect/code', method: 'POST', data }, { interceptResultCode: false });
};

// 获取祈愿或者交换或者赠与链接状态
export const cherryStatus = (data) => {
  return axios({ url: '/cherry/collect/card', method: 'POST', data }, { interceptResultCode: false });
};

// 通过赠送链接赠送道具
export const receive = (data) => {
  return axios({ url: '/cherry/collect/receive', method: 'POST', data }, { interceptResultCode: false });
};


// 交换卡片
export const exchange = (data) => {
  return axios({ url: '/cherry/collect/exchange', method: 'POST', data }, { interceptResultCode: false });
};

// 祈愿赠与道具
export const generateGave = (data) => {
  return axios({ url: '/cherry/collect/gave', method: 'POST', data }, { interceptResultCode: false });
};

// 免密登录
export const secretFreeLoginApi = (data) => {
  return axios({ url: '/cherry/auth/login', method: 'POST', data }, { interceptResultCode: false });
};

// 支付
export const onPayAPI = (data) => {
  return axios({ url: '/game/clock/pay', method: 'POST', data });
};

// 订单查询
export const onQueryOrderAPI = (params) => {
  return axios({ url: '/game/clock/show', method: 'GET', params }, { interceptResultCode: false });
};

// 退款
export const onRefundAPI = (params) => {
  return axios({ url: '/game/clock/refund', method: 'GET', params });
};

// 获取打卡信息
export const getCardInfoAPI = (params) => {
  return axios({ url: '/game/clock/sing', method: 'GET', params });
};

// codeId查询api
export const wechatInfoAPI = (params) => {
  return axios({ url: '/wechat/info', method: 'GET', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/sakura/card/api.js